import { AppBox } from "../../../../commons/components";
import { ManageFootballTeam } from "../../../../commons/models/football/admin/manage-football-team";

interface TeamActivateProps {
  team: ManageFootballTeam;
}
export default function TeamActivate({ team }: TeamActivateProps) {
  return (
    <AppBox displayBlock>
      Once you activate team <strong>“{team.name}”</strong>, the team will be able to participate in any tournament.
    </AppBox>
  );
}
